import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { LANDING } from "@/constants/testIds";

const FAQS = [
  {
    q: "Does it work offline?",
    a: "Core mobile sales, stock and customer-credit workflows are local-first. They can be queued during weak connectivity and synchronized when service returns, with retry and conflict handling built into the process.",
  },
  {
    q: "Can my staff use it?",
    a: "Yes. You can invite staff with PIN login and grant role-based permissions for sales, inventory or reporting. Every action is attributed to the staff member who made it.",
  },
  {
    q: "Can I manage multiple branches?",
    a: "Yes. Switch between branches in one tap and see sales, stock and debts per branch. A combined dashboard rolls up everything across your business.",
  },
  {
    q: "Does it track customer debt?",
    a: "Yes. Record credit sales with customer name and amount, follow up on unpaid balances, and see who owes you at a glance.",
  },
  {
    q: "Can I use it without accounting knowledge?",
    a: "Absolutely. Shopbook is built for shop owners, not accountants. The interface uses everyday language and simple flows.",
  },
  {
    q: "What languages are supported?",
    a: "English, Arabic, French, Hausa, Igbo, Portuguese, Swahili, Yoruba and Zulu.",
  },
  {
    q: "How can I use Shopbook across devices?",
    a: "The full web app is available now. You can request access to the Android or iPhone beta from the hero. Those same buttons switch to the official store listings when each public release is available.",
  },
  {
    q: "Is my business data secure?",
    a: "Yes. Shopbook uses secure authentication with PIN login, OTP verification, role-based permission control and encrypted session handling.",
  },
];

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid={LANDING.faq}
      className="bg-white py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <span className="text-xs md:text-sm tracking-[0.2em] uppercase font-bold text-[#D96C4A]">FAQ</span>
            <h2 className="mt-4 font-display text-3xl md:text-4xl font-semibold leading-[1.1] text-[#0A2424] tracking-tight">
              Questions, <span className="italic text-[#0E6B6B]">honestly</span> answered.
            </h2>
            <p className="mt-5 text-[#4B5E5E]">
              Still have a question? Contact our support team and we’ll help you choose the right starting point.
            </p>
          </div>
          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={f.q}
                  value={`item-${i}`}
                  className="border-b border-[#0E6B6B]/12"
                  data-testid={LANDING.faqItem(i)}
                >
                  <AccordionTrigger className="text-left font-display text-lg md:text-xl text-[#0A2424] hover:text-[#0E6B6B] py-6">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-[15px] md:text-base text-[#4B5E5E] leading-relaxed pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
